'use client';

import _, { debounce } from 'lodash';
import { classNames } from 'primereact/utils';
import { type ReactNode, useCallback, useEffect, useRef, useState } from 'react';
import { MdClose, MdSearch } from 'react-icons/md';
//import style from './search-bar.module.css';
import { placesRepository, X4bLocation } from '../../views/PlacesRepository';
import { cn } from '@/components/ui/cn';
import { showError } from '@/modules/notification/engine/notification.library';
import { Column, Row } from '@/components/container/Container';

interface Props {
	// placeholder?: string;
	// onSelect: (item: T) => void;
	// onChange: (item: string) => void;
	// filterMethod: (item: T, query: string) => boolean;
	// label: keyof T;
	// labelIcon?: ReactNode;
	// description?: keyof T | null;
	// value?: string;
	className?: string;
	// inputClassName?: string;
	// iconClassName?: string;
	// forceSelection?: boolean;
	onLocationSelected?: (location: X4bLocation) => void;
}

const PickAddressInput = (props: Props) => {
	const {
		className,
	} = props;

	const [filteredResults, setFilteredResults] = useState<X4bLocation[]>([]);
	const [expanded, setExpanded] = useState<boolean>(false);
	const [searchValue, setSearchValue] = useState<string>('');
	const [location, setLocation] = useState<X4bLocation | null>(null);
	const searchRef = useRef<HTMLDivElement>(null);
	const inputRef = useRef<HTMLInputElement>(null);

	// // Filter function for search
	// useEffect(() => {
	// 	if (!value) {
	// 		setFilteredResults([]);
	// 	} else {
	// 		const filtered = suggestions.filter((item) =>
	// 			filterMethod(item, value),
	// 		);
	// 		setFilteredResults(_.uniqBy(filtered, label));
	// 	}
	// }, [value, suggestions, filterMethod, label]);

	const debouncedSearch = useCallback(
		debounce(async (value: string) => {
			if (value.trim().length == 0) setFilteredResults([])
			else {
				try {
					const result = await placesRepository.searchPlaces(value);
					setFilteredResults(result);
				} catch (error) {
					showError('Failed to fetch addresses', { summary: 'Error' });
				}
			}
		}, 300), []
	);

	useEffect(() => {
		if (!expanded) return;
		debouncedSearch(searchValue);
		return () => debouncedSearch.cancel();
	}, [searchValue, debouncedSearch]);

	// // Handle selecting a suggestion
	const handleSelect = (result: X4bLocation) => {
		setLocation(result);
		setSearchValue(result.Address);
		setExpanded(false);
		props.onLocationSelected?.(result); // Call external function
	};

	// Close dropdown when clicking outside
	useEffect(() => {
		const handleClickOutside = (event: MouseEvent) => {
			if (
				searchRef.current &&
				!searchRef.current.contains(event.target as Node)
			) {
				setExpanded(false);
			}
		};
		document.addEventListener('mousedown', handleClickOutside);
		return () =>
			document.removeEventListener('mousedown', handleClickOutside);
	}, []);

	return (
		<div className={cn("max-w-full", className)} ref={searchRef}>
			{/* Search Input Box */}
			<div
				className={cn(
					{
						'rounded-t-3xl': expanded,
						'rounded-3xl': !expanded,
					},
					'p-4 h-14 border-0 w-full text-lg text-onSurfaceVariant bg-white shadow-none font-poppins',
				)}
			>
				<div className="flex items-center">
					<div className='pr-3'>
						<img
							src="/images/concierge/live-map/pickup-completed-location.svg"
							alt="Pickup location"
							width={24}
							height={24}
							className={cn(
								'text-onSurfaceVariant mr-2',
								//iconClassName,
							)}
						/>
					</div>
					<input
						ref={inputRef}
						type="text"
						value={searchValue}
						onChange={(e) => {
							setSearchValue(e.target.value);
							setExpanded(true);
						}}
						placeholder={'Enter a location'}
						className={cn(
							'bg-transparent text-onSurface focus:outline-none w-full pr-4',
							//inputClassName,
						)}
					/>
					{searchValue ?
						<MdClose
							size={28}
							className={cn(
								'text-onSurfaceVariant mr-2 cursor-pointer',
								//iconClassName,
							)}
							onClick={() => {
								setLocation(null);
								setSearchValue('');
								inputRef.current?.focus();
							}}
						/> :
						<MdSearch
							size={28}
							className={cn(
								'text-onSurfaceVariant mr-2',
								//iconClassName,
							)}
						/>}
				</div>
			</div>

			{/* Search Suggestions Dropdown */}
			{expanded && (

				<div
					className={'w-full bg-white z-50 rounded-b-3xl max-h-80 overflow-auto border-t border-[#004060]'}
				>
					{filteredResults.length > 0 ? (
						filteredResults.map((location: X4bLocation, index) => (
							<div
								key={`${index}`}
								onClick={() => handleSelect(location)}
								onKeyDown={(e) => {
									// Check for Enter or Space key press to trigger the click action
									if (e.key === 'Enter' || e.key === ' ') {
										handleSelect(location);
									}
								}}
								className={
									'cursor-pointer pl-[14px] pr-4 py-2 hover:bg-surfaceContainerHighest rounded'
								}
							>

								<Row>
									<Column className='pr-3 justify-center !w-[40px] shrink-0'>

										<img
											src="/images/concierge/live-map/drop_blue.svg"
											alt="Pickup location"
											width={28}
											height={28}
											className={cn(
												'text-onSurfaceVariant mr-2',
												//iconClassName,
											)}
										/>
										{/* {<MdSearch
										size={24}
										className={classNames(
											'text-onSurfaceVariant mr-2',
										)}
									/>} */}
									</Column>
									<Column>
										<div className="flex items-center text-body-large text-onSurface">

											{String(location.PlaceName)}


										</div>
										<p className="text-onSurfaceVariant text-body-medium">
											{String(location.Address)}
										</p>
									</Column>

								</Row>




							</div>
						))
					) : (
						<div className="text-body-large text-onSurface px-4 py-2">
							No results found.
						</div>
					)}
				</div>
			)}
		</div>
	);
};

export default PickAddressInput;
